// List of badges we display on the profile section among the whole badges list
export const PROFILE_SELLER_BADGES = ['fashion-activist', 'trusted-seller', 'expert-seller', 'official-store'];
